/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityHistoryV1Dto } from '../models/EntityHistoryV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EntityHistoryService {
  /**
   * @param entityId the uuid of the entity
   * @returns EntityHistoryV1Dto a entity list
   * @throws ApiError
   */
  public static entityHistoryClientControllerV1FindAllV1(
    entityId: string,
  ): CancelablePromise<Array<EntityHistoryV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/entity-history/{entityId}',
      path: {
        entityId: entityId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
